import { LoaderFunctionArgs, RouteObject } from 'react-router';

import { Artists } from '@/ui/pages/external/festival/artists/Artists';
import { ArtistsAccommodation } from '@/ui/pages/external/festival/artists-accommodation/ArtistsAccommodation';
import { ArtistsCargo } from '@/ui/pages/external/festival/artists-cargo/ArtistsCargo';
import { ArtistsCatering } from '@/ui/pages/external/festival/artists-catering/ArtistsCatering';
import { ArtistsMobility } from '@/ui/pages/external/festival/artists-mobility/ArtistsMobility';
import { Public } from '@/ui/pages/external/festival/public/Public';
import { PublicSupplier } from '@/ui/pages/external/festival/public-supplier/PublicSupplier';
import { Site } from '@/ui/pages/external/festival/site/Site';
import { SiteBuilding } from '@/ui/pages/external/festival/site-building/SiteBuilding';
import { SiteEnergyWaterWaste } from '@/ui/pages/external/festival/site-energy-water-waste/SiteEnergyWaterWaste';
import { SiteEquipmentCargo } from '@/ui/pages/external/festival/site-equipment-cargo/SiteEquipmentCargo';
import { Team } from '@/ui/pages/external/festival/team/Team';
import { TeamAccommodation } from '@/ui/pages/external/festival/team-accommodation/TeamAccommodation';
import { TeamCatering } from '@/ui/pages/external/festival/team-catering/TeamCatering';
import { TeamMobility } from '@/ui/pages/external/festival/team-mobility/TeamMobility';

import { externalLoader } from '../externalLoaders';

export const externalFestivalRoutes: RouteObject[] = [
  // Festival : full form
  {
    path: 'artists',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'ARTISTS' }),
    element: <Artists />,
  },
  {
    path: 'team',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'TEAM' }),
    element: <Team />,
  },
  {
    path: 'public-supplier',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'PUBLIC_SUPPLIER' }),
    element: <PublicSupplier />,
  },
  {
    path: 'site',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'SITE' }),
    element: <Site />,
  },
  {
    path: 'public',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'PUBLIC', loadAnswers: false }),
    element: <Public />,
  },
  // Festival: team-categories
  {
    path: 'team-mobility',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'TEAM-MOBILITY' }),
    element: <TeamMobility />,
  },
  {
    path: 'team-catering',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'TEAM-CATERING' }),
    element: <TeamCatering />,
  },
  {
    path: 'team-accommodation',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'TEAM-ACCOMMODATION' }),
    element: <TeamAccommodation />,
  },
  // Festival: artists-categories
  {
    path: 'artists-mobility',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'ARTISTS-MOBILITY' }),
    element: <ArtistsMobility />,
  },
  {
    path: 'artists-catering',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'ARTISTS-CATERING' }),
    element: <ArtistsCatering />,
  },
  {
    path: 'artists-accommodation',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'ARTISTS-ACCOMMODATION' }),
    element: <ArtistsAccommodation />,
  },
  {
    path: 'artists-cargo',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'ARTISTS-CARGO' }),
    element: <ArtistsCargo />,
  },
  // Festival: site-categories
  {
    path: 'site-energy-water-waste',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'SITE-ENERGY-WATER-WASTE' }),
    element: <SiteEnergyWaterWaste />,
  },
  {
    path: 'site-equipment-cargo',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'SITE-EQUIPMENT-CARGO' }),
    element: <SiteEquipmentCargo />,
  },
  {
    path: 'site-building',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'SITE-BUILDING' }),
    element: <SiteBuilding />,
  },
];
